import dayjs from 'dayjs';
import { CreateUserUrl, CreateAccountUrl, UserRequirementsUrl, DocumentsUploadUrl, GetHeardAboutUrl, GetApplicationInvestigationStatusUrl, UploadApplicationDocumentUrl, UploadInvestigationDocumentUrl, DuplicateAccountCheckUrl, UploadMiscellaneousDocumentsUrl, } from '../constants';
import { DateFormats } from '..';
import { RequestHeaders } from './utilities';
export function Application(api) {
    return {
        getUserRequirements: () => {
            return api.get(UserRequirementsUrl, undefined, RequestHeaders);
        },
        getHeardAbout: (siteConfigId) => {
            return api.get(GetHeardAboutUrl(siteConfigId), {}, RequestHeaders);
        },
        getApplicationStatus: (accountId) => {
            return api.authenticated().get(GetApplicationInvestigationStatusUrl(accountId), undefined, RequestHeaders);
        },
        createUser: (data) => {
            return api.post(CreateUserUrl, data, RequestHeaders);
        },
        uploadDocument: (file, tag) => {
            const TakenOn = dayjs(file.lastModified)
                .utc()
                .format(DateFormats.DateTimeApiFormat);
            const data = new FormData();
            data.append('metaData', JSON.stringify({ tag, ImageName: file.name, TakenOn }));
            data.append('file', file);
            // NOTE: when posting multipart/form-data, not passing Accept: 'application/json' header (see: https://stackoverflow.com/a/35206069)
            return api
                .authenticated()
                .post(DocumentsUploadUrl, data)
                .then((res) => (Object.assign({}, res, { payload: { id: res.payload, filename: file.name } })));
        },
        uploadMiscDocument: (file, accountId, primary, documentType) => {
            const TakenOn = dayjs(file.lastModified)
                .utc()
                .format(DateFormats.DateTimeApiFormat);
            const uploadFormData = new FormData();
            uploadFormData.append('metaData', JSON.stringify({ DocumentName: documentType, ImageName: file.name, TakenOn, AccountHolder: primary ? 0 : 1 }));
            uploadFormData.append('file', file);
            return api.authenticated().post(UploadMiscellaneousDocumentsUrl(accountId), uploadFormData);
        },
        uploadApplicationDocument: (file, accountId, accountHolderId, documentType) => {
            const TakenOn = dayjs(file.lastModified)
                .utc()
                .format(DateFormats.DateTimeApiFormat);
            const uploadFormData = new FormData();
            uploadFormData.append('metaData', JSON.stringify({ DocumentName: documentType, ImageName: file.name, TakenOn }));
            uploadFormData.append('file', file);
            return api
                .authenticated()
                .post(UploadApplicationDocumentUrl(accountId, accountHolderId), uploadFormData);
        },
        uploadInvestigationDocument: (file, accountId, investigationId, documentType) => {
            const TakenOn = dayjs(file.lastModified)
                .utc()
                .format(DateFormats.DateTimeApiFormat);
            const uploadFormData = new FormData();
            uploadFormData.append('metaData', JSON.stringify({ DocumentName: documentType, ImageName: file.name, TakenOn }));
            uploadFormData.append('file', file);
            return api
                .authenticated()
                .post(UploadInvestigationDocumentUrl(accountId, investigationId), uploadFormData);
        },
        createAccount: (data) => {
            return api.authenticated().post(CreateAccountUrl, data, RequestHeaders);
        },
        duplicateAccountCheck: (data) => {
            return api.authenticated().post(DuplicateAccountCheckUrl, data, RequestHeaders);
        },
    };
}
//# sourceMappingURL=application.js.map